import { baseApi } from 'api/api-base';
import { API_ROUTES } from 'constants/api-routes';
import { GetProductsData } from 'types/api/api-products.types';

export const productsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getProductsData: builder.query<GetProductsData.ResponseType, GetProductsData.RequestType>({
      query: () => ({
        url: API_ROUTES.GET_PRODUCTS_DATA,
      }),
      extraOptions: {},
      transformResponse: (response: GetProductsData.RawApiResponse): GetProductsData.ResponseType => {
        return {
          products: response.Products.map(p => ({
            productId: p.ProductId,
            organizationId: p.OrganizationId,
            minerTypeId: p.MinerTypeId,
            model: p.Model,
            manufacturer: p.Manufacturer,
            coin: p.Coin,
            wattage: p.Wattage,
            terahashes: p.Terahashes,
            price: p.Price,
            balance: p.Balance,
            deposit: p.Deposit,
            condition: p.Condition,
            orderType: p.OrderType,
            location: p.Location,
            soldOut: p.SoldOut,
            topSeller: p.TopSeller,
            imageUri: p.ImageUri,
            electricitySellingPrice: p.ElectricitySellingPrice,
          })),
        };
      },
    }),
  }),
});

export const { useGetProductsDataQuery } = productsApi;
